export default __webpack_public_path__ + "static/media/home_flask.eac9d05c.svg";